import React from "react";

/**
 * Maps a credit card name to a local image in /public/cards
 * Uses exact matches first, then issuer-level fallbacks
 */
function imageForCardName(name) {
  const n = (name || "").toLowerCase();

  // ===== CHASE =====
  if (n.includes("freedom unlimited")) return "/cards/chase_freedom_unlimited.png";
  if (n.includes("freedom flex")) return "/cards/chase_freedom_flex.png";
  if (n.includes("sapphire preferred")) return "/cards/chase_sapphire_preferred.png";
  if (n.includes("sapphire reserve")) return "/cards/chase_sapphire_preferred.png";

  
  // ===== CAPITAL ONE =====
if (n.includes("capital one platinum secured")) return "/cards/capitalone_platinum.png";
if (n.includes("capital one platinum")) return "/cards/capitalone_platinum.png";
if (n.includes("platinum secured")) return "/cards/capitalone_platinum.png";
if (n.includes("quicksilver")) return "/cards/capitalone_generic.png";
if (n.includes("venture")) return "/cards/capitalone_generic.png";
if (n.includes("savor")) return "/cards/capitalone_generic.png";
if (n.includes("capital one")) return "/cards/capitalone_generic.png";

// ===== AMERICAN EXPRESS =====
if (n.includes("amex") || n.includes("american express")) {
  if (n.includes("blue cash")) return "/cards/amex_blue_cash.png";
  return "/cards/amex_generic.png";
}

  // ===== CITI =====
  if (n.includes("simplicity")) return "/cards/citi_simplicity.png";
  if (n.includes("citi")) return "/cards/citi_generic.png";

  // ===== BANK OF AMERICA =====
  if (n.includes("bankamericard")) return "/cards/bofa_bankamericard.png";
  if (n.includes("bank of america")) return "/cards/bofa_bankamericard.png";

  // ===== DISCOVER =====
  if (n.includes("discover")) return "/cards/discover.png";

  // ===== WELLS FARGO =====
  if (n.includes("wells")) return "/cards/wells_fargo.png";

  // ===== PETAL =====
  if (n.includes("petal")) return "/cards/petal_1.png";

  // fallback
  return "/cards/chase_freedom_unlimited.png";
}

function Card({ item, label }) {
  const { card, reasons = [] } = item;

  return (
    <div className="recCard fadeIn">

      {/* 🔹 LABEL / RANK */}
      <div className="recHeader">
        <div className="rankLabel">{label}</div>
      </div>

      {/* 🔹 CARD CONTENT */}
      <div className="recContent">
        <img
          className="cardImage"
          src={imageForCardName(card.cardName)}
          alt={card.cardName}
          draggable="false"
        />

        <div className="cardDetails">
          <h3 className="cardTitle">{card.cardName}</h3>

          <div className="meta">
            <div><strong>Type:</strong> {card.cardType}</div>
            <div><strong>Rewards:</strong> {card.rewardType}</div>
            <div><strong>Annual Fee:</strong> ${card.annualFee}</div>
          </div>

          <p className="description">{card.description}</p>

          <ul className="reasons">
            {reasons.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Card;
